import React from "react";
import { Linkedin, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export const SidebarSocialLinks = () => {
  return (
    <>
      <Separator className="my-2" />
      <div className="text-sm text-sidebar-foreground/80 text-center mb-2">
        Keep up with us on socials
      </div>
      <div className="flex justify-center gap-2">
        <Button
          variant="secondary"
          size="icon"
          className="h-8 w-8 bg-white hover:bg-primary/5 
            border-2 border-primary/50 hover:border-primary
            shadow-sm hover:shadow-md hover:shadow-primary/20
            transition-all duration-300 
            hover:scale-105
            text-primary
            group"
          asChild
        >
          <a href="https://linkedin.com/company/linkpilot-pro" target="_blank" rel="noopener noreferrer">
            <Linkedin className="h-4 w-4" />
          </a>
        </Button>
        <Button
          variant="secondary"
          size="icon"
          className="h-8 w-8 bg-white hover:bg-primary/5 
            border-2 border-primary/50 hover:border-primary
            shadow-sm hover:shadow-md hover:shadow-primary/20
            transition-all duration-300 
            hover:scale-105
            text-primary
            group"
          asChild
        >
          <a href="https://x.com/linkpilot_pro" target="_blank" rel="noopener noreferrer">
            <Twitter className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </>
  );
};